import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UrlFormatter } from 'shared';

/**
 * Native port of the v1 `ConfirmationImage` factory (account-v1/src/core/api/
 * confirmationImage.js). WS5 #10 Stage A inc 2w: replaces the
 * `$injector.get('ConfirmationImage')` grab in ft-touchpoint-messaging (the
 * activate()-time `refresh` that creates a missing confirmation banner image —
 * skipped on quebec where images exist). Both methods resolve the response BODY
 * (v1 `.then(r => r.data)`). The v1 URL building is kept verbatim: propertyUuid
 * CONCATENATED into the template, touchpointUUID as a token, and for `refresh`
 * the languageCode rides the QUERY STRING (appendSearch) on a no-body POST.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmationImageV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `ConfirmationImage.updateBackground(touchpointUUID, image, propertyUuid)`. */
  updateBackground(touchpointUUID: string, image: any, propertyUuid: string): Promise<any> {
    return firstValueFrom(
      this.http.put(
        UrlFormatter.format(
          '/api/' + propertyUuid + '/properties/layers/prestay/touchpoints/:touchpointUUID/confirmation-email-image/styling/background',
          { touchpointUUID },
        ),
        { backgroundImage: image },
      ),
    );
  }

  /** v1 `ConfirmationImage.refresh(touchpointUUID, languageCode, propertyUuid)`. */
  refresh(touchpointUUID: string, languageCode: string, propertyUuid: string): Promise<any> {
    const url = UrlFormatter.format(
      '/api/' + propertyUuid + '/properties/layers/prestay/touchpoints/:touchpointUUID/confirmation-email-image/refresh',
      { touchpointUUID, languageCode },
      true,
    );
    return firstValueFrom(this.http.post(url, null));
  }
}
